import { Download } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';

interface DownloadProps {
  filePath: string;
}

export const DownloadComponent: React.FC<DownloadProps> = ({ filePath }) => {
  const [fileName, setFileName] = useState<string>('');
  const [fileSize, setFileSize] = useState<number | null>(null);
  const [fileType, setFileType] = useState<string>('');

  useEffect(() => {
    // Fetch file metadata dynamically
    fetch(filePath)
      .then((response) => {
        if (!response.ok) throw new Error('File not found');
        return response.blob();
      })
      .then((blob) => {
        setFileName(filePath.split('/').pop() || 'Unknown File'); // Extract file name
        setFileSize(blob.size); // Get file size in bytes
        setFileType(blob.type || 'Unknown'); // Get MIME type
      })
      .catch((error) => console.error('Error fetching file:', error));
  }, [filePath]);

  return (
    <div className="flex items-center justify-between border p-4 rounded-lg bg-gray-100 shadow-md w-full max-w-lg">
      <div className="flex items-center space-x-3">
        <div className="bg-red-100 p-2 rounded-md">
          <span className="text-red-600 font-bold">
            {fileType.split('/')[1]?.toUpperCase() || 'FILE'}
          </span>
        </div>
        <div>
          <p className="font-semibold">{fileName}</p>
          {fileSize !== null && (
            <p className="text-sm text-gray-500">{(fileSize / 1024).toFixed(2)} KB</p>
          )}
        </div>
      </div>
      <a
        href={filePath}
        download={fileName}
        className="text-blue-600 hover:text-blue-800 transition"
      >
        <Download />
      </a>
    </div>
  );
};
